import React, {useEffect, useState} from 'react';
import { PopUp } from './components'
import {useDispatch, useSelector} from "react-redux";
import { getCurrentAccountId, getCurrentClubId,
  getUnreadMessageList, getOpenedMessages
} from "../../store/selectors";
import { requestUnreadMessages, setCountOfUnreadMessages } from "../../store/actionCreators/messages";

const PopUpMessages = ({}) => {
    const dispatch = useDispatch();
    const openedMessages = useSelector(getOpenedMessages);
    const [messages, setMessages] = useState([]);

    const messageList = useSelector(getUnreadMessageList);
    const accountId = useSelector(getCurrentAccountId);
    const arrMessages = messageList[accountId] || [];
    const clubId = useSelector(getCurrentClubId);

    useEffect(() => {
        if(!!accountId && !!messageList)
        dispatch(requestUnreadMessages());
    }, [accountId]);

    useEffect(() => {
        if( !!arrMessages ) {
            const msgs = arrMessages.filter(msg => (!openedMessages.includes(msg._id) && msg.status === 'unread'));
            const count = msgs.length;
            setMessages(msgs);
            dispatch(setCountOfUnreadMessages(count));
        }
    }, [messageList, openedMessages, clubId]);

    return (
        <React.Fragment>
            { !!messages &&
                <div className={`msgContents`}>
                    { messages.map(msg => <PopUp key={msg._id} msg={msg} accountId={accountId} />)}
                </div>
            }
        </React.Fragment>
    )
};

export default PopUpMessages;
